import { useMeterPct, useVisitor } from "~/lib/store";

export function MeterBar() {
  const pct = useMeterPct();
  const visitedCount = useVisitor((s) => s.facesVisited.length);
  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-[3px]"
      role="progressbar"
      aria-label="Exploration progress"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuetext={`${visitedCount} of 6 faces explored`}
    >
      <div
        className="h-full bg-gradient-to-r from-jg-augment via-jg-play to-jg-trade transition-[width] duration-700 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
